import React from "react";
import { mapToPdfData } from "../utils/pdfDataMapper";
import { generatePDFFromData } from "../utils/exportPDF";

const generateItineraryPDF = async (itineraryData) => {
  const data = mapToPdfData(itineraryData, "itinerary");
  const name = itineraryData.itineraryname || itineraryData.packagename || "export";
  const filename = `itinerary_${name.replace(/\s+/g, "_")}.pdf`;
  await generatePDFFromData(data, filename);
};

export const ItineraryPDFButton = ({ itineraryData }) => (
  <button
    className="p-2 bg-gray-200 rounded-md"
    onClick={() => generateItineraryPDF(itineraryData)}
  >
    <span className="material-symbols-outlined">picture_as_pdf</span>
  </button>
);

export { generateItineraryPDF };
